import React, { useContext, useEffect, useState } from 'react';
import { useApiPortalV1AssessmentsResultsListQuery } from 'areas/assessment-schedule/api';
import Tabs from 'common/components/Tabs';
import { getCurrentOrganization, getCurrentOrganizationId, getSelectedAssessmentPeriodId } from 'common/selectors/auth';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { PageContent, PageSection } from '../../../common/styles/page';
import OutcomesIndividual from './OutcomesIndividual';
import OutcomesOrganization from './OutcomesOrganization';
import OutcomesGroup from './OutcomesGroup';
import { TopBarContext } from 'common/layouts/AuthLayout/TopBarContext';
import TopBarControls from 'common/layouts/AuthLayout/TopBarAssessmentPeriod';
import OutcomesQuestions from './OutcomesQuestions';
import { ASSESSMENT_PERIOD_CLOSED } from 'areas/assessment-schedule/constants';

import { AggregateType } from 'common/constants/AggregateType';
const OrgOutcomes = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isEmployeeRecordsEnabled, setIsEmployeeRecordsEnabled] = useState(false);
  const [searchParams] = useSearchParams();

  const currentOrganization = useSelector(getCurrentOrganization);
  const assessmentPeriodId = useSelector(getSelectedAssessmentPeriodId);
  const organizationId = useSelector(getCurrentOrganizationId);
  const { setTopBarContent } = useContext(TopBarContext);

  const { data: employee_records } = useApiPortalV1AssessmentsResultsListQuery({
    aggregateType: AggregateType.MEMBER_PILLARS,
    assessmentPeriodId: assessmentPeriodId,
  });

  useEffect(() => {
    const orgSettingEnabled = currentOrganization?.employeeRecordsEnabled;
    setIsEmployeeRecordsEnabled(Boolean(orgSettingEnabled));
  }, [employee_records, currentOrganization, organizationId]);

  useEffect(() => {
    const showTopBar =
      selectedTab === 0 ||
      selectedTab === 1 ||
      selectedTab === 2 ||
      (isEmployeeRecordsEnabled && selectedTab === 3);

    if (showTopBar) {
      const topBarStatus: React.ComponentProps<typeof TopBarControls>['status'] = [
        ASSESSMENT_PERIOD_CLOSED,
      ];

      setTopBarContent(<TopBarControls status={topBarStatus} />);
    } else {
      setTopBarContent(null);
    }

    return () => setTopBarContent(null);
  }, [selectedTab, isEmployeeRecordsEnabled, setTopBarContent]);

  const tabs = ['Organization', 'Questions', 'Group', ...(isEmployeeRecordsEnabled ? ['Individual'] : [])];

  const tab = Number(searchParams.get('tab'));
  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);

  return (
    <PageContent data-testid="admin-outcomes-page">
      <Tabs
        data-testid="admin-outcomes-nav"
        options={tabs}
        onSelect={(item: React.SetStateAction<number>) => setSelectedTab(item)}
        selected={selectedTab}
        borderbottom
      />

      {tabs[selectedTab] === 'Organization' && (
        <PageSection padright data-testid="admin-outcomes-content">
          <OutcomesOrganization />
        </PageSection>
      )}

      {tabs[selectedTab] === 'Questions' && (
        <PageSection padright data-testid="admin-outcomes-areas">
          <OutcomesQuestions assessmentPeriodId={assessmentPeriodId} />
        </PageSection>
      )}

      {tabs[selectedTab] === 'Group' && (
        <PageSection padright data-testid="admin-outcomes-content">
          <OutcomesGroup />
        </PageSection>
      )}

      {isEmployeeRecordsEnabled && tabs[selectedTab] === 'Individual' && (
        <PageSection data-testid="admin-outcomes-content">
          <OutcomesIndividual />
        </PageSection>
      )}
    </PageContent>
  );
};

export default OrgOutcomes;

